import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { PremiumStores } from '@/services/premiumStores/premiumStores.types';
import { getColumns } from './Column';

export function RejectedStoreTable({
  data,
  isLoading,
  pagination,
}: {
  data: PremiumStores[];
  isLoading: boolean;
  pagination: Pagination;
}) {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const { table } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
    },
    meta: {
      title: t('storeManagement.premiumStores.table.title.rejectedStores'),
      loading: isLoading,
      totalPage: pagination.totalItems,
    },
    getRowId: (originalRow) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table} className="rounded-t-none">
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
